export default {
  "content": "<path d=\"M18.207 9.707l-2.293 2.292 2.293 2.293-1.414 1.415-2.293-2.293-2.293 2.293-1.414-1.415L13.086 12l-2.293-2.292 1.414-1.415 2.293 2.293 2.293-2.293 1.414 1.415z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21 4a1 1 0 011 1v14a1 1 0 01-1 1H9a1 1 0 01-.707-.294l-7-7a1 1 0 010-1.413l7-7 .073-.067C8.544 4.08 8.768 4 9 4h12zM3.414 12l6 6H20V6H9.414l-6 6z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};